var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldRichText, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Fragment, PureComponent } from 'react';
import { connect } from 'react-redux';
import { Field, Form, reduxForm, } from 'redux-form';
import { WidgetPreview } from 'components/conversation/components/widgetPreview';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import SelectField from 'components/shared/util/SelectField';
const FORM_NAME = 'chatFlowQueueForm';
const validate = (values) => {
    let errors = {};
    if (!values) {
        return errors;
    }
    if (!values.payload || !values.payload.queue || !values.payload.queue.value) {
        errors = {
            payload: {
                queue: {
                    value: 'Required - please select a queue',
                },
            },
        };
    }
    return errors;
};
function stripTagsAndTrim(value) {
    var _a;
    const tempDiv = document.createElement('div');
    // TODO: [TEAMS-12081] Investigate improper use of innerHTML
    tempDiv.innerHTML = value;
    const textContent = (_a = tempDiv === null || tempDiv === void 0 ? void 0 : tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.trim();
    return textContent || '';
}
class QueueModal extends PureComponent {
    handleSaveClick(values) {
        var _a, _b;
        let selectedQueue;
        if ((_b = (_a = values.payload) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.value) {
            const matchingQueue = this.props.queuesState.find((queue) => { var _a, _b; return queue.id === ((_b = (_a = values.payload) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.value); });
            if (matchingQueue) {
                selectedQueue = {
                    value: matchingQueue.id,
                    label: matchingQueue.name,
                };
            }
        }
        const trimmedMessage = values.message && stripTagsAndTrim(values.message);
        const payload = {
            queue: selectedQueue,
            welcome_message: trimmedMessage ? values.message : null,
        };
        const nodeOptionsText = `Queue ${selectedQueue.label ? `(${selectedQueue.label})` : ''}`;
        const nodeOptions = Object.assign(Object.assign(Object.assign({}, this.props.node), values), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.QUEUE, overlay: [], payload, text: nodeOptionsText });
        this.props.replaceNode(nodeOptions);
        this.props.triggerClose();
    }
    closeModal() {
        const { destroy, triggerClose } = this.props;
        destroy();
        triggerClose();
    }
    render() {
        var _a;
        const { handleSubmit, queueValue, messageValue, node, nodeLabel, queuesState, } = this.props;
        const { payload } = node;
        const listQueues = (queue) => {
            return (_jsx("option", Object.assign({ value: queue.id }, { children: queue.name }), queue.id));
        };
        const isChanged = queueValue !== ((_a = payload === null || payload === void 0 ? void 0 : payload.queue) === null || _a === void 0 ? void 0 : _a.value) ||
            stripTagsAndTrim(messageValue) !==
                stripTagsAndTrim((payload === null || payload === void 0 ? void 0 : payload.welcome_message) || '');
        return (_jsx("div", Object.assign({ className: "conversational-modal queue modal-chatflow-holder" }, { children: _jsxs(Form, Object.assign({ onSubmit: handleSubmit(this.handleSaveClick) }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.closeModal }, { children: "A queue is where a conversation is queued until an available agent can support the customer." })), _jsxs(ModalBody, { children: [_jsx("div", Object.assign({ className: "conversational-modal__columns" }, { children: _jsxs(Field, Object.assign({ displayName: "Queue", name: "payload.queue.value", className: "conversational-modal__field", component: SelectField }, { children: [_jsxs("option", Object.assign({ hidden: true, value: "" }, { children: [' ', "- Please select a queue"] })), queuesState.map(listQueues)] })) })), _jsxs(Fragment, { children: [_jsxs("p", Object.assign({ className: "conversational-modal__text" }, { children: ["Here you can write the message that will welcome the user to the chat with your agent.", _jsxs("strong", { children: [' ', "Remember to animate the user to start typing a message to your agent in order to start the chat."] }), ' ', "If you leave this message blank, the user will see \u201CWelcome! How can we help you?\u201D in the languages of your widget customization"] })), _jsxs("div", Object.assign({ className: "conversational-modal__columns" }, { children: [_jsx("div", Object.assign({ className: "conversational-modal__column" }, { children: _jsx(WidgetPreview, { message: messageValue, className: "conversational-modal__preview" }) })), _jsx("div", Object.assign({ className: "conversational-modal__column" }, { children: _jsx(Field, { component: FieldRichText, name: "message", className: "conversational-modal__editor", label: "Your message" }) }))] }))] })] }), _jsx(ModalFoot, { confirmOnClick: handleSubmit(this.handleSaveClick), confirmName: getConfirmButtonVerb(node), confirmProps: { disabled: !isChanged }, cancelOnClick: this.closeModal })] })) })));
    }
}
__decorate([
    boundMethod
], QueueModal.prototype, "handleSaveClick", null);
__decorate([
    boundMethod
], QueueModal.prototype, "closeModal", null);
const ChatFlowQueueForm = reduxForm({
    form: FORM_NAME,
    enableReinitialize: true,
    validate,
})(QueueModal);
export default connect((state) => {
    var _a, _b;
    const form = state.form[FORM_NAME];
    return {
        queueValue: (form === null || form === void 0 ? void 0 : form.values) ? (_b = (_a = form.values.payload) === null || _a === void 0 ? void 0 : _a.queue) === null || _b === void 0 ? void 0 : _b.value : '',
        messageValue: (form === null || form === void 0 ? void 0 : form.values) ? form.values.message : '',
    };
})(ChatFlowQueueForm);
